import Vue from 'vue';

export const RELOAD_NOTES_LIST = 'RELOAD_NOTES_LIST';
export const Event = new Vue();
